import { render, staticRenderFns } from "./CollapsableRow.vue?vue&type=template&id=77994316&scoped=true"
import script from "./CollapsableRow.vue?vue&type=script&lang=js"
export * from "./CollapsableRow.vue?vue&type=script&lang=js"
import style0 from "./CollapsableRow.vue?vue&type=style&index=0&id=77994316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77994316",
  null
  
)

export default component.exports